import React, { useEffect, useState } from "react";
import getUser from "../services/decodeJWT";
import ApiService from '../services/ApiService';
import Nav from "../components/Nav";
import Sidebar from "../components/Sidebar";
import CloneProfile from "../components/CloneProfile";
import ModalCall from "../components/modals/ModalCall";
import ModalVideocall from "../components/modals/ModalVideocall";

const CloneList = () => {
  const [clones, setClones] = useState([]);
  const [currentClone, setCurrentClone] = useState({});
  const [mobileActive, setMobileActive] = useState(false);

  const [loading, setLoading] = useState(false);

  const currentUser = getUser();

  useEffect(() => {
    const getClones = async () => {
      try {
        setLoading(true);
        const response = await ApiService.get(`/cms/clones?limit=1000&author=${currentUser?._id}`);
        setClones(response?.contents);
        setLoading(false);
      } catch (err) {
        console.error("Error during getting clones:", err);
        setLoading(false);
      }
    };

    getClones();

  }, [currentUser?._id]);

  useEffect(() => {
    if (clones?.length > 0) {
      setCurrentClone(clones[0]);
    }
  }, [clones]);

  return (
    <div className="tyn-root cloneList">
      <Nav />
      <div className={`tyn-content tyn-contact d-flex justify-content-center align-items-center ${clones.length > 0 ? "has-aside-base" : ""}`}>
        <Sidebar data={{ clones, setClones, currentClone, setCurrentClone, loading, setLoading, mobileActive, setMobileActive }} />
        <CloneProfile data={{ clones, setClones, currentClone, setCurrentClone, loading, mobileActive, setMobileActive }} />
      </div>
      <ModalCall cloneData={currentClone?.data} />
      <ModalVideocall cloneData={currentClone?.data} />
    </div>
  );
};

export default CloneList;
